module.exports = __webpack_public_path__ + "arrow-slide-next@2x.png?6407625f46f58d75487255e029911242";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-slide-next@2x.png
// module id = 25
// module chunks = 0